import state from '~store/modules/referrals/state'
import actions from '~store/modules/referrals/actions'

export default {
  state,
  actions
}
